import { gql, useMutation, useQuery } from "@apollo/client";

import {
  Brand,
  Subsidiary,
  SyncCollectionAssetsInput,
} from "../../../generated/gql/graphql";

const GET_BRANDS = gql`
  query Brands($query: BrandQuery) {
    brands(query: $query) {
      items {
        name
        id
      }
    }
  }
`;

const GET_SUBSIDIARIES = gql`
  query Subsidiaries {
    subsidiaries {
      name
      id
    }
  }
`;

const GET_SYNC_COLLECTION_ASSETS = gql`
  mutation SyncCollectionAssets($input: SyncCollectionAssetsInput!) {
    syncCollectionAssets(input: $input)
  }
`;

interface OutpusProps {
  brands: Brand[];
  subsidiaries: Subsidiary[];
  loading: boolean;
  syncAssetsLoading: boolean;
  syncAssetsData: any;

  onSyncCollectionAssets: (
    input: SyncCollectionAssetsInput
  ) => Promise<unknown>;
}

export const useCollectionSyncModal = (): OutpusProps => {
  const { loading: loadingBrands, data: brandsData } = useQuery(GET_BRANDS);
  const { loading: loadingSubsidiaries, data: subsidiariesData } =
    useQuery(GET_SUBSIDIARIES);
  const [
    syncCollectionAssets,
    { loading: syncAssetsLoading, data: syncAssetsData },
  ] = useMutation(GET_SYNC_COLLECTION_ASSETS);
  const loading = loadingBrands || loadingSubsidiaries;

  async function onSyncCollectionAssets(
    input: SyncCollectionAssetsInput
  ): Promise<unknown> {
    return await syncCollectionAssets({
      variables: {
        input: {
          ...input,
        },
      },
    });
  }

  return {
    brands: brandsData?.brands?.items ?? [],
    subsidiaries: subsidiariesData?.subsidiaries ?? [],
    loading,
    syncAssetsLoading,
    syncAssetsData,
    onSyncCollectionAssets,
  };
};
